<template>
    <div>
        <div id="placeholder1"></div>
    </div>
</template>

<script>
    export default {
        name: "newEditor",
        props: ['config'],
        data: function() {
            return {
                docEditor: '',
                events: {
                    'onDocumentReady': this.onDocumentReady,
                    'onAppReady': this.onAppReady,
                    'onGetDocumentContent': this.onGetDocumentContent,
                    'onDocumentStateChange': this.onDocumentStateChange,
                    'onResetFocus': this.onResetFocus,
                    'onDistPartAuth': this.onDistPartAuth,
                    'onTypeDataChangeEvent': this.onTypeDataChangeEvent,
                    'onError': this.onError,
                  "onEndComapreEvent":this.onEndComapreEvent,
                }
            }
        },
        created() {
            this.config["events"] = this.events;
            console.log("config", this.config)
        },
        mounted() {
            setTimeout( () => {
                this.connectEditor();
            }, 500)
        },
        methods: {
          connectEditor: function () {
            if (CXO_API) {

                  this.docEditor = new CXO_API.CXEditor("placeholder1", this.config);
                  window["docEditor"] = this.docEditor ;
                    log("config===", this.config)
                    this.$emit("onGetEditor", this.docEditor)
                } else {
                    log("CXO_API is not defined")
                }
            },
            // 编辑器加载完成时回调事件
            onAppReady: function () {
                console.log("编辑器加载完成");
            },
            // 文档加载完成时回调事件
            onDocumentReady: function () {
                console.log("文档已加载完成");
                this.getCtctrlTree();
            },
            // 文档修改时回调事件
            onDocumentStateChange: function (event) {
                if(event.data) {
                    console.log("文档已修改")
                    this.getCtctrlTree()
                }
          },
          // 文档修改时回调事件
          onError: function (event) {
            if (event.data) {
              console.log("文档已修改")
            }
          },
            onGetDocumentContent: function (event) {
                // console.log(JSON.stringify(event.data));

                // 储存编辑器返回的提取的 data 并传递给父组件
                console.log("eventtt",event)
                var data = event.data;
                // console.log('response data:', data);
                this.$emit('onGetDocContent', data)
                console.log(data,'nnnnn')
            },
            // 如果编辑器之外的页面有获取焦点的操作，需要添加此事件，事件写法固定
            onResetFocus: function (event) {
                log("onResetFocus")
                var active = document.activeElement;
                log("active", active)
                document.activeElement.blur(); //编辑器外失去焦点
            },
            onDistPartAuth: function (event) { //修改权限触发事件，返回相关参数
                log("onDistPartAuth: ", event)
            },
            getCtctrlTree: function () {
                var expression = {
                    object:"content",
                    type: "contentControlChildren",
                };
                this.docEditor.getDocumentContent(expression);
            },
          onEndComapreEvent: function(){
            // console.log("compareEnd")
            // window.alert("链接已发到网盘！");
            if (document.getElementsByClassName('el-message').length == 0) {
              this.$message({
                message: '链接已发到网盘！',
                type: 'success'
              });
            }

          },
        }
    }
</script>

<style>
    .CXO_container {
        margin-top: 50px;
        height: 750px;
        width: 1400px;
    }
</style>




// WEBPACK FOOTER //
// src/views/newEditor.vue